import React, { useState } from 'react'
import { 
    Box,
    Button,
    IconButton,
    Paper,
    Step,
    StepLabel, 
    Stepper, 
    TextField, 
    Typography 
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircleIcon from '@mui/icons-material/Circle';

import ListaDiagramas from './ListaDiagramas';
import { BlockPicker, TwitterPicker } from 'react-color';
import ColeccionesCheckBox from './ColeccionesCheckBox';


const steps = ['Nombre', 'Seleccionar colección/es', 'Guardar'];

const DiagramaStep = (props) => {

    const {
        handleClose, 
        crearColeccion, 
        guardarNuevo,
        setTitulo,
        titulo,
        nombreColeccion,
        setColorColeccion,
        colorColeccion,
        setColeccionesDiagrama,
        coleccionesDiagrama
    } = props;

    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    const [mostrarColor, setMostrarColor] = useState('');
    const [colorActual, setColorActual] = useState(colorColeccion)

    const cambiarColor = (color)=>{
        setColorActual(color.hex);
        setColorColeccion(color.hex);
    }

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };


    const handleReset = () => {
        setActiveStep(0);
    };


    return (
        <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                        labelProps.optional = (
                        <Typography variant="caption">Optional</Typography>
                        );
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

            {activeStep === steps.length ? (
                <>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                        All steps completed - you&apos;re finished
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button onClick={handleReset}>Reset</Button>
                    </Box>
                </>
            ) : (
                <>
                   
                    <br/>
                    {activeStep === 0 && (
                        <Paper 
                            component="form"
                            style={{color: 'red'}}
                            sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: 400,
                                
                            }}    
                        > 
                            
                            <TextField 
                                sx={{ flex: 1 }}
                                label="Nombre diagrama" 
                                variant="outlined"
                                value={titulo} 
                                onChange={(e)=>{setTitulo(e.target.value)}}
                            />
                            {
                            mostrarColor ? 
                            (
                                <div style={ {
                                    position: 'absolute',
                                    zIndex: '2',
                                    marginTop: '130px',
                                    marginLeft: '9px'
                                }}>
                                    <div 
                                        style={{
                                            position: 'fixed',
                                            top: '0px',
                                            right: '0px',
                                            bottom: '0px',
                                            left: '0px',
                                        }}
                                        onClick={()=>{setMostrarColor(!mostrarColor)}}
                                    />
                                    
                                    <TwitterPicker
                                        color={ colorActual } 
                                        onChange={ cambiarColor }
                                    />
                                </div> 
                            )
                            :
                            (
                                null
                            )
                        }
                        </Paper>
                    )} 
                    {activeStep === 1 && (
                        <ColeccionesCheckBox
                            setColeccionesDiagrama={setColeccionesDiagrama}
                            coleccionesDiagrama={coleccionesDiagrama}
                        />
                    )}
                    {activeStep === 2 && (
                        <Typography variant="h5" align='center'>
                            Presione 'Finalizar' para guardar el diagrama.
                        </Typography>
                    )}  
                    
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <IconButton
                            color={"primary"}
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            <ArrowBackIosIcon/>
                        </IconButton>
                    <Box sx={{ flex: '1 1 auto' }} />

                    { activeStep === steps.length-1 ?
                        (<Button onClick={guardarNuevo} >Finalizar</Button>)
                        :
                        (
                            <IconButton 
                                onClick={handleNext} 
                                color='primary'
                            >
                                <ArrowForwardIosIcon/>
                            </IconButton>
                        )
                    }
                    
                    </Box>
                </>
            )}
        </Box>
    )
}

export default DiagramaStep